import React, { useState } from "react";
import SwipeableDrawer from "@mui/material/SwipeableDrawer";
import CloseIcon from "@mui/icons-material/Close";
import { Box, Typography } from "@mui/material";
import BottomCalenderModal from "./BottomCalenderModal";

const filters = [
  "Any Day",
  "This week",
  "This weekend",
  "Next weekend",
  "Next week",
  "Custom",
];

export default function BottomWhenModal({
  open,
  toggleDrawer,
  setSelectedWhen,
}) {
  const [openCalenderModal, setOpenCalenderModal] = useState(false);

  const handleSelect = (e) => {
    if (e.target.innerHTML !== "Custom") {
      setSelectedWhen(e.target.innerHTML);
    } else {
      setOpenCalenderModal(true);
    }
  };
  console.log(openCalenderModal);
  return (
    <>
      <SwipeableDrawer
        anchor="bottom"
        open={open}
        onClose={toggleDrawer(false)}
        PaperProps={{
          sx: {
            height: "400px",
            borderRadius: "16px 16px 0px 0px",
            boxShadow:
              "0px -8px 10px rgba(0, 0, 0, 0.14), 0px -3px 14px rgba(0, 0, 0, 0.12), 0px -5px 5px rgba(0, 0, 0, 0.2)",
          },
        }}
      >
        <CloseIcon
          onClick={toggleDrawer(false)}
          sx={{
            marginTop: "18px",
            marginLeft: "18px",
            "&:hover": {
              cursor: "pointer",
            },
          }}
        />
        <Box
          sx={{
            display: "flex",
            width: "100%",
            flexDirection: "column",
            marginTop: "30px",
            marginBottom: "28px",
            textAlign: "center",
            rowGap: "24px",
          }}
        >
          {filters.map((f) => (
            <Typography
              variant="body1"
              fontWeight="400"
              fontSize="16px"
              lineHeight="24px"
              color="text.primary"
              onClick={handleSelect}
              sx={{
                "&:hover": {
                  color: "primary.main",
                  cursor: "pointer",
                },
              }}
            >
              {f}
            </Typography>
          ))}
        </Box>
      </SwipeableDrawer>
      <BottomCalenderModal
        open={openCalenderModal}
        toggleDrawer={setOpenCalenderModal}
        setSelectedWhen={setSelectedWhen}
        whenToggle={toggleDrawer}
      />
    </>
  );
}
